import {EventDispatcher} from '@megaphonenpm/mputils/src/EventDispatcher.js';
import {CHANGE, COMPLETE} from '@megaphonenpm/mputils/src/constants.js';
import {LoadRankingsTask} from './LoadRankingsTask.js';

/**
 * Provides a centralized location through which to load all rankings for the current playlist in
 * the supplied dataStore.
 */
export class RankingsDataManager extends EventDispatcher {

  constructor (dataStore) {
    super();

    this.dataStore = dataStore;
    this.loadRankingsIntervalID = -1;
    this.refreshInProgress = false;
  }

  start () {
    this.stop();
    this.loadRankingsIntervalID = setInterval(() => {
      this.refresh();
    }, RankingsDataManager.AUTO_REFRESH_INTERVAL);
  }

  stop () {
    clearInterval(this.loadRankingsIntervalID);
  }

  /**
   * Updates the dataStore's Web Polls and dispatches a CHANGE event when the Web Polls have
   * finished loading.
   */
  refresh () {
    if (!this.refreshInProgress) {
      this.refreshInProgress = true;
      let loadRankingsTask = new LoadRankingsTask(this.dataStore);
      loadRankingsTask.on(COMPLETE, () => {
        if (loadRankingsTask.changedRankingIDs.length > 0) {
          this.dispatchEvent(CHANGE, {changedRankingIDs: loadRankingsTask.changedRankingIDs});
        }
        this.refreshInProgress = false;
        this.dispatchEvent(COMPLETE);
      });
      loadRankingsTask.start();
    }
  }
}

RankingsDataManager.AUTO_REFRESH_INTERVAL = 10000;
